import * as Sentry from "@sentry/react";
import uuid from "react-uuid";
import { AppCrashedPage, AppCrashedContent } from "etl/design-system/organisms/ErrorBoundary";
import { ErrorFallback } from "./constants/ErrorBoundary.type";

export interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: ErrorFallback;
}

export const ErrorBoundary = (props: ErrorBoundaryProps) => {
  const { children, fallback = ErrorFallback.CONTENT } = props;

  const FallbackComponent = fallback === ErrorFallback.PAGE ? AppCrashedPage : AppCrashedContent;
  const codeError = uuid();

  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag("codeError", codeError);
      }}
      fallback={(props) => (
        <FallbackComponent {...props} codeError={codeError} />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
};
